<template>
  <div class="controller">
    <b-input-group class="control" size="sm">
      <template #prepend>
        <b-input-group-text v-if="prependIcon" v-b-tooltip.hover :title="fieldName" @click="emitClicked">
          <fa :icon="prependIcon"/>
        </b-input-group-text>
        <b-input-group-text v-else @click="emitClicked">{{ prepend || fieldName }}</b-input-group-text>
      </template>
      <b-form-input :type="inputType" :value="value" @input="updateModel"></b-form-input>
      <template #append v-if="append">
        <div class="append-container">
          <div class="append-text">{{ append }}</div>
        </div>
      </template>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'Controller',
  props: {
    value: { required: true },
    prepend: { type: String, required: false, default: null },
    inputType: { type: String, required: false, default: 'number' },
    append: { type: String, required: false, default: 'px' },
    prependIcon: { type: String, required: false, default: null },
    fieldName: { type: String, required: true },
  },
  methods: {
    updateModel(value) {
      this.$emit('input', this.fieldName, this.inputType === 'number' ? parseInt(value, 10) : value);
    },
    emitClicked() {
      this.$emit('field-clicked', this.fieldName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.controller {
  width: 100%;

  .append-container {
    display: flex;
    align-items: center;
    background-color: $riseup_gray_0;
    .append-text {
      font-size: 9px;
      padding: 0 5px;
    }
  }
  // remove arrows in number boxes because they just take up space and wont be used
  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
